import cx from 'classnames';
import {useCallback} from 'react';

import './styles.scss';

type Option<T extends string> = {
    value: T;
    label: string;
};

export type SegmentedControlProps<T extends string> = {
    options: Option<T>[];
    value: T;
    disabled?: boolean;
    ariaLabel?: string;
    onChange: (value: T) => void;
};

export const SegmentedControl = <T extends string>({
    options, value, disabled = false, ariaLabel, onChange,
}: SegmentedControlProps<T>) => {
    const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        onChange(event.currentTarget.value as T);
    }, [onChange]);

    return (
        <div className='vs-segmented-control' role='group' aria-label={ariaLabel}>
            {options.map((option) => (
                <button
                    key={option.value}
                    type='button'
                    value={option.value}
                    className={cx('segment', {selected: value === option.value})}
                    aria-pressed={value === option.value}
                    disabled={disabled || value === option.value}
                    onClick={handleClick}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};
